'use client';

import React from 'react';

const EnvContext = React.createContext({
	env: [],
});

export default EnvContext;
